module.exports = __webpack_public_path__ + "img/no-active-employees.b942e99f.webp";